import { Button } from '@heroui/react';
import styled from 'styled-components';

import { media } from '@/utils';

export const StepRoot = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const StepTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};
`;

export const StepText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

export const PhoneValue = styled.span`
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};
`;

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 12px;
  font-size: 13px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
`;

export const CodeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ErrorText = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f87171' : '#dc2626')};
`;

export const SuccessText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#4ade80' : '#15803d')};
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;

  ${media.mobile} {
    flex-direction: column-reverse;

    & > button {
      width: 100%;
    }
  }
`;

// Tekstowy przycisk „Wyślij ponownie” z odliczaniem: drugorzędna akcja, nie konkuruje z „Potwierdź”.
export const ResendButton = styled(Button)`
  align-self: flex-start;
  height: 40px;
  min-height: 40px;
  padding: 0 4px;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#111827')};
  text-decoration: underline;
  text-underline-offset: 3px;

  &:disabled {
    text-decoration: none;
    opacity: 1;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#6b7280' : '#9ca3af')};
    cursor: default;
  }
`;

// Kontener niewidocznej reCAPTCHA: nie zajmuje miejsca, odznakę Google pozycjonuje sama.
export const RecaptchaHost = styled.div`
  width: 0;
  height: 0;
  overflow: visible;
`;

// Komunikaty etapów tylko dla czytników ekranu (wysyłanie, kod wysłany, sprawdzanie).
export const LiveRegion = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;
